'use client';

import { useEffect } from 'react';

export function ProductViewTracker({
  productId,
  productSku,
  productName,
  productCategory,
  value,
  currency = 'EUR',
}: {
  productId: string;
  productSku?: string | null;
  productName: string;
  productCategory?: string | null;
  value: number;
  currency?: string;
}) {
  useEffect(() => {
    window.printenTrack?.('view_item', {
      productId,
      productSku,
      productName,
      productCategory,
      item_category: productCategory,
      value,
      currency,
      contentIds: [productId],
      contents: [{ id: productId, quantity: 1, item_price: value }],
    });
  }, [productId, productSku, productName, productCategory, value, currency]);

  return null;
}
